export const BACKUP_CREATE_RESET = 'BACKUP_CREATE_RESET'
export const BACKUP_CREATE_SET_CREATED = 'BACKUP_CREATE_SET_CREATED'
export const BACKUP_CREATE_SET_ERROR = 'BACKUP_CREATE_SET_ERROR'
export const BACKUP_CREATE_SET_VIOLATIONS = 'BACKUP_CREATE_SET_VIOLATIONS'
export const BACKUP_CREATE_TOGGLE_LOADING = 'BACKUP_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup/create/mutation_types.js